import IProject from "common/interfaces/IProject";
import styled from "styled-components";

interface ChatPreviewProps {
  data: IProject;
  isOpen: boolean;
  isChatOpen: boolean;
  onClick: any;
}

const WrapperBasic = styled.div`
  cursor: pointer;
`;

const Wrapper = styled(WrapperBasic)(
  ({ isOpen, isChatOpen }: { isOpen: boolean; isChatOpen: boolean }) => ({
    backgroundColor: isOpen ? "#E3C7FF" : "transparent",
    padding: isChatOpen ? "0 23px" : "0 20px",
  })
);

const PreviewWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 0;
`;

const UserPic = styled.div`
  border: 1px black solid;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  position: relative;
`;

const ChatTitle = styled.h3`
  margin-left: 10px;
`;

// const Indicator = styled.span`
//   width: 12px;
//   height: 12px;
//   border-radius: 50%;
//   background-color: #ce1c1c;
//   position: absolute;
//   border: none;
//   top: -1px;
//   right: -1px;
// `;

const ChatPreview = ({
  data,
  isOpen,
  isChatOpen,
  onClick,
}: ChatPreviewProps) => {
  return (
    <Wrapper
      isOpen={isChatOpen && isOpen}
      isChatOpen={isChatOpen}
      onClick={onClick}
    >
      <PreviewWrapper>
        <UserPic>{/* <Indicator /> */}</UserPic>
        {isChatOpen && <ChatTitle>{data?.title}</ChatTitle>}
      </PreviewWrapper>
    </Wrapper>
  );
};

export default ChatPreview;
